module.exports = __webpack_public_path__ + "browserconfig-d662904e11f8567923c3e1236dca608d.xml";